import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";

export const editorHeader = css`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: ${spacings.l};
`;
